import { Injectable } from '@angular/core';
import { Actions, createEffect } from '@ngrx/effects';
import { EMPTY, Observable } from 'rxjs';
import { switchMap, take, tap } from 'rxjs/operators';
import { CheckoutPersistenceService } from '../services/checkout-persistence.service';

/*
 * Нельзя имплементрировать OnRunEffects. так как эффект checkoutPersistanseSync
 * должен выполниться один раз, а не при каждом заходе на страницу чекаута
 * Также нельзя checkoutPersistenceService.sync() перенести на APP_INITIALIZER
 * потому что на экшены вызываемые в нем не успевают реагировать эффекты на запуске приложения
 *  */
@Injectable()
export class CheckoutInitEffects {
  checkoutInit$: Observable<void> = createEffect(
    () =>
      this.actions$.pipe(
        take(1),
        tap(() => {
          this.checkoutPersistenceService.sync();
        }),
        switchMap(() => EMPTY),
      ),
    { dispatch: false },
  );

  constructor(
    private actions$: Actions,
    private checkoutPersistenceService: CheckoutPersistenceService,
  ) {}
}
